import { useTranslation } from 'react-i18next';
import { Modal, message } from 'ui';
import { PostForm, type PostFormValues } from '../post-form';
import { useCreatePost } from '../queries';

type P = {
  isOpened: boolean;
  onCancel: () => void;
};

const CreateJournalNoteModal = ({ isOpened, onCancel }: P) => {
  const { t } = useTranslation();
  const { isPending: isLoading, mutate: createPost } = useCreatePost();

  const onSubmit = (values: PostFormValues) => {
    createPost(
      {
        attachments: values.attachments.files,
        htmlContent: values.htmlContent,
        textContent: values.textContent,
      },
      {
        onSuccess() {
          message.success(t('Your {{content}} has been published', { content: t('note') }));
          onCancel();
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title={t('Create note')} width="medium">
      <Modal.HugContent>
        <PostForm isLoading={isLoading} mode="create" onSubmit={onSubmit} type="journal" />
      </Modal.HugContent>
    </Modal>
  );
};

export default CreateJournalNoteModal;
